module.exports = __webpack_public_path__ + "static/media/9DESA14.b79c693d.jpg";